<template>
    <div v-if="!loading" class="row justify-content-center" style="margin-left: -50px; margin-right: -50px;">
        <div class="col-8">
            <template v-for="(base, index) in bases">
                <b-card :key="index" no-body class="mb-2">
                    <b-card-header>
                        <div
                            class="col d-flex flex-column flex-md-row text-center text-md-left justify-content-md-between align-items-center">
                            <span class="col mb-2 mb-md-0"><b>Deportista: </b>{{ base.nombre_completo }}</span>
                            <span class="col mb-2 mb-md-0"><b>Nº de plazos: </b>{{ base.n_plazos }}</span>
                            <router-link
                                :to="{ name: 'plazos', params: { tipo_plazo: 'base', tipo_id: base.id } }"
                                class="md-col btn btn-primary"
                            >
                                Ver plazos
                            </router-link>
                        </div>
                    </b-card-header>
                </b-card>
            </template>
            <div class="d-flex justify-content-center" v-if="bases">
                <PaginateComponent 
                    :current_page="pagination.current_page" 
                    :last_page="pagination.last_page"
                    v-on:change_page="setPage"
                />
            </div>
        </div>
    </div>
    <div style="padding: 50px;" v-else>
        <LoaderComponent></LoaderComponent>
    </div>
</template>

<script>
import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";

export default {
    data() {
        return {
            bases: null,
            loading: false,
            pagination: {},
            page: 1
        }
    },
    created() {
        this.getBases();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        getBases() {
            this.loading = true;

            const data = {
                filters: {
                    tid: this.configuracion.hash_teatro,
                    page: this.page
                },
                tid : this.configuracion.hash_teatro
            }

            this.$store.dispatch(this.config.getVuexAlias('front.perfil.bases'), data).then(res => {
                this.bases = res.data.data;
                this.pagination = res.data.meta;
                this.loading = false;
            });
        },
        setPage(page) {
            this.page = page;
            this.getBases();
        },
    },
    components: {
        PaginateComponent
    }
}
</script>